import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
import type { ChatMessage } from '@/types/chat'

const WINDOW_SECONDS = 24 * 60 * 60

/**
 * Janela de 24h de mensagens do WhatsApp: fora dela só é possível responder com
 * template — texto livre, anexo, áudio e vídeo ficam bloqueados até o cliente
 * enviar uma nova mensagem (o que reabre a janela automaticamente, já que o
 * cálculo é sempre em função da última mensagem incoming).
 */
export function useMessageWindow(
  messages: Ref<ChatMessage[]> | ComputedRef<ChatMessage[]>,
  nowSec: Ref<number> | ComputedRef<number>,
) {
  const lastIncomingAt = computed(() => {
    const msgs = messages.value
    for (let i = msgs.length - 1; i >= 0; i--) {
      if (msgs[i].message_type === 0) return msgs[i].created_at
    }
    return null
  })

  const isWindowClosed = computed(() => {
    const ts = lastIncomingAt.value
    return ts != null && nowSec.value - ts >= WINDOW_SECONDS
  })

  return { isWindowClosed }
}
